import { FC } from 'react'
import theme from 'theme'
import { FormControlLabel, Radio, RadioGroup, FormLabel, RadioGroupProps } from '@mui/material'
import { FormControl } from './styles/formikRadioGroup.styles'
import { RadioUncheckedIcon } from '../svg'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'

export interface RadioGroupOption {
  name: string
  label: string | JSX.Element
  value: string
}

type Props = RadioGroupProps & {
  name: string
  label?: string
  value: string
  onChange: (e: any) => void
  options: RadioGroupOption[]
  formControlSx?: Record<string, unknown>
  disabled?: boolean
}

const FormikRadioGroup: FC<Props> = ({ name, value, onChange, label, options, formControlSx, disabled, ...rest }) => (
  <FormControl sx={formControlSx}>
    {label && <FormLabel disabled={disabled}>{label}</FormLabel>}
    <RadioGroup name={name} value={value} onChange={onChange} {...rest}>
      {options.map((n, index: number) => (
        <FormControlLabel
          value={n.value}
          disabled={disabled}
          control={
            <Radio
              disabled={disabled}
              checkedIcon={
                <RadioButtonCheckedIcon
                  sx={{
                    color: disabled ? theme.colors.legacyPrimaryLight : theme.colors.menuItemText,
                    width: '16px',
                    height: '16px'
                  }}
                />
              }
              icon={
                <RadioUncheckedIcon stroke={disabled ? theme.colors.primaryLight : theme.baseColors.greyscale[80]} />
              }
            />
          }
          label={n.label}
          key={index}
        />
      ))}
    </RadioGroup>
  </FormControl>
)

export default FormikRadioGroup
